import { ContentCopy, DeleteOutline, Lock } from "@mui/icons-material";
import { Button, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../components";
import { PublishedIcon } from "../../images/svg/publishedIcon";
import { WIPIcon } from "../../images/svg/WIPIcon";

export const DashboardTableColumn = (onDelete: any, view: any, getPath: (id: string) => string, updatePublishStatus: any, hideDelete?: boolean, handleDuplicate?: any, publishable?: boolean) => {
    const columns: GridColDef[] = [
        {
            field: 'sequence_id', headerName: 'Quick Quote ID', width: 120, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return (
                    <Stack direction="row" spacing={1} sx={{
                        alignItems: "center"
                    }}>
                        <Typography
                            id="view-quote-icon"
                            component={"a"}
                            href={getPath(params.row?._id)}
                            onClick={(e) => {
                                e.preventDefault();
                                view(params.row);
                            }}
                            variant="body2"
                            color="primary"
                            sx={{ cursor: "pointer", textDecoration: "underline" }}>
                            {params.row.sequence_id}
                        </Typography>
                        {params.row?.user_access ? <Tooltip title={`This ${params.row.sequence_id} is private`}><Lock color='disabled' fontSize={"small"} /></Tooltip> : <></>}
                    </Stack>
                );
            }
        },
        {
            field: 'version', headerName: 'Revision', width: 100, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography
                    variant="body2"
                >
                    {params.row?.version}
                </Typography>
            }
        },
        {
            field: "duplicate",
            headerName: "Duplicate",
            resizable: true,
            width: 90,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === "group") {
                    return params.value;
                }
                return (
                    <Tooltip title="Make a Duplicate">
                        <IconButton
                            sx={{ margin: "auto" }}
                            onClick={() =>
                                handleDuplicate && handleDuplicate(params?.row)
                            }
                        >
                            <ContentCopy fontSize="small" />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
        {
            field: "released",
            headerName: "Status",
            width: 80,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    params?.row?.released ? (
                        <Button disableRipple disableFocusRipple sx={{ cursor: "default", '&:hover': { backgroundColor: 'transparent' } }}>
                            <Tooltip
                                title="Published"
                                children={<div><PublishedIcon /></div>}
                            />
                        </Button>
                    ) : (
                        <Button disableRipple disableFocusRipple id="publish-material">
                            <Tooltip
                                title={publishable ? "Work in progress, click to publish the item" : "Not Published"}
                                children={
                                    <div><WIPIcon onClick={() => publishable ? updatePublishStatus(params.row) : true} /></div>
                                }
                            />
                        </Button>
                    )
                );
            },
        },
        {
            field: 'name', headerName: 'Name', width: 200, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Tooltip title={params.row.name}>
                    <Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {params.row.name}
                    </Typography>
                </Tooltip>
            }
        },
        { field: 'currency_code', headerName: 'Currency' },
        // {
        //     field: 'status', headerName: 'Status', width: 250,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_status)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'status') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_status).map((tag: any) => <Chip variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_status)?.[0]?.tag_name ?? "";
        //     },
        // },
        // {
        //     field: 'priority', headerName: 'Priority', width: 200,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_priority)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'status') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_priority).map((tag: any) => <Chip variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_priority)?.[0]?.tag_name ?? "";
        //     },
        // },
        { field: 'serial_num', headerName: 'Custom Reference No.', width: 200 },
        // {
        //     field: 'tags_info', headerName: 'Tags', width: 250,
        //     valueGetter: (value, row, column, apiRef) => { return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_tg)?.[0]?.tag_name ?? "" },
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'tags_info') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }
        //         return (
        //             <Stack
        //                 spacing={1}
        //                 direction={"row"}
        //                 id={"tagsChip"}
        //                 sx={{
        //                     width: "100%",
        //                 }}>
        //                 {params.row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_tg).map((tag: any) => <Chip variant="outlined" sx={{ borderColor: tag.tag_group_color, backgroundColor: tag.tag_group_color, color: `${hexToGrayscale(tag.tag_group_color) > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} size={"small"} label={tag?.tag_name ?? ""} />)}
        //             </Stack>
        //         );
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return row.tags_info?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_tg)?.[0]?.tag_name ?? "";
        //     },
        // },
        {
            field: 'date_of_issue', headerName: 'Created Date', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{moment(params.row.date_of_issue).format(DATE_TIME_FORMAT)}</Typography>
            }
        },
        {
            field: 'valid_till', headerName: 'Valid Till', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{moment(params.row.valid_till).format(DATE_TIME_FORMAT)}</Typography>
            }
        },
        { field: 'created_user', headerName: 'Created By', width: 150 },
        {
            field: 'created_time', headerName: 'Created At', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{moment(params.row.created_time).format('lll')}</Typography>
            }
        },
        { field: 'modified_user', headerName: 'Last modified by', width: 150 },
        {
            field: 'modified_time', headerName: 'Last modified date', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{params.row.modified_time ? moment(params.row.modified_time).format('lll') : ""}</Typography>
            }
        },
        { field: 'released_user', headerName: 'Published by', width: 150 },
        {
            field: 'released_time', headerName: 'Published date', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{params.row.released_time ? moment(params.row.released_time).format('lll') : ""}</Typography>
            }
        },
        {
            field: 'delete', headerName: 'Delete', width: 100, renderCell: (params: GridRenderCellParams) => {
                return (
                    <Tooltip title={params?.row?.released ? `${params?.row?.sequence_id} Revision is published` : `Delete the Quote ${params?.row?.sequence_id}`}>
                        <IconButton disableRipple={params?.row?.released} onClick={() => params?.row?.released ? () => { } : onDelete(params.row)}>
                            <DeleteOutline color={params?.row?.released ? "disabled" : "error"} id="delete-quote-icon" />
                        </IconButton>
                    </Tooltip>
                );
            },
            disableColumnMenu: true,
            sortable: false,
        },
    ];

    if (hideDelete) {
        columns.pop();
    }

    return columns;
};